import { useTheme } from '@mui/material'
import { SxProps, Theme } from '@mui/material/styles'
import Typography from '@mui/material/Typography'
import { ColorChip } from 'color_chip/color_chip'
import { TemperTestAvatar } from 'icon_avatar/icon_avatar'

export interface DiscountTagProps {
  tempTestName: string
  cssOverrides?: SxProps<Theme>
  iconColor?: string
}

export const TempTestTag = ({ tempTestName, cssOverrides, iconColor }: DiscountTagProps) => {
  const theme = useTheme()

  return (
    <ColorChip
      icon={
        <TemperTestAvatar
          fillColor={iconColor || theme.palette.info.light}
          backgroundColor="inherit"
          data-testId="TemperTestIcon"
        />
      }
      label={<Typography style={{ fontWeight: 600, fontSize: 12 }}>{tempTestName}</Typography>}
      sxOverrides={{
        display: 'flex',
        justifyContent: 'flex-start',
        borderRadius: 1,
        backgroundColor: theme.palette.background.info,
        color: theme.palette.info.darken60,
        '& .MuiChip-label': {
          paddingLeft: 0,
        },
        ...cssOverrides,
      }}
    />
  )
}
